export default "__VITE_ASSET__B1OB9BN8__"